import * as Yup from 'yup';
import Validators from '../../../utils/validatorsHelper';

/* VALIDAÇÃO PARA EVENTOS */
export const SaidaEventoValidationSchema = Yup.object().shape({
	isEvento: Yup.bool().required('Campo obrigatório'),
	origemEstoque: Yup.object().shape({
		id: Yup.string().required('Campo obrigatório'),
	}),
	ocorrencia: Yup.object().shape({
		id: Yup.string().required('Campo obrigatório'),
	}),
	quantidadeEntradaSaida: Yup.string().test('quantidadeEntradaSaida', 'Quantidade não deve ser inferior a 1', (value) => {
		if (value) {
			return Number(value) > 0;
		}
		return false;
	}).required('Campo obrigatório'),
});

/* VALIDAÇÃO PARA NÃO EVENTOS */
export const SaidaNaoEventoValidationSchema = Yup.object().shape({
	isEvento: Yup.bool().required('Campo obrigatório'),
	origemEstoque: Yup.object().shape({
		id: Yup.string().required('Campo obrigatório'),
	}),
	motivo: Yup.string().nullable().trim().required('Campo obrigatório'),
	documento: Yup.string().nullable().required('Campo obrigatório'),
	quantidadeEntradaSaida: Yup.string().test('quantidadeEntradaSaida', 'Quantidade não deve ser inferior a 1', (value) => {
		if (value) {
			return Number(value) > 0;
		}
		return false;
	}).required('Campo obrigatório'),

});

export const MovimentacaoValidationSchema = Yup.object().shape({
	quantidadeEntradaSaida: Yup.string().test('quantidadeEntradaSaida', 'Quantidade não deve ser inferior a 1', (value) => {
		if (value) {
			return Number(value) > 0;
		}
		return false;
	}).required('Campo obrigatório'),
	recebedor: Yup.string().trim().required('Campo obrigatório'),
	destinoEstoque: Yup.object().shape({
		id: Yup.string().required('Campo obrigatório'),
	}),
	origemEstoque: Yup.object().shape({
		id: Yup.string().required('Campo obrigatório'),
	}),
});

export const EntradaArpValidationSchema = Yup.object().shape({
	id: Yup.string().required('Campo obrigatório'),
	tipoTransacao: Yup.string().required('Campo obrigatório'),
	quantidadeEntradaSaida: Yup.string().test('quantidadeEntradaSaida', 'Quantidade não deve ser inferior a 1', (value) => {
		if (value) {
			return Number(value) > 0;
		}
		return false;
	}).required('Campo obrigatório'),
	destinoEstoque: Yup.object().shape({
		tipoEstoque: Yup.string().required('Campo obrigatório'),
		numero: Yup.string().nullable().required('Campo obrigatório').test('numero', 'Campo obrigatório', (value) => {
			if (value) {
				return value.match(/\d{4}([/])\d{4,1000}/g);
			}
			return false;
		}),
		valorUnitario: Yup.string().required('Campo obrigatório').test('valorUnitario', 'Valor deve ser maior que R$0,00', (value) => {
			const double = value ? value.replace(/[^\d]/g, '') : null;
			if (double) {
				return Number(double) > 0;
			}
			return false;
		}),
		validade: Yup.string().required('Campo obrigatório'),
		crepdecs: Yup.array().min(1, 'Selecione pelo menos uma CREPDEC').required('Campo obrigatório'),
		empresa: Yup.object().shape({
			nome: Yup.string().trim().required('Campo obrigatório'),
			cnpj: Yup.string()
				.test('cnpj', 'CNPJ inválido', (val) => {
					if (val === undefined) {
						return false;
					}
					return Validators.validarCNPJ(val);
				})
				.required('Campo obrigatório'),
			email: Yup.string()
				.test('email', 'Informe um e-mail válido', val => Validators.validarEmail(val))
				.required('Campo obrigatório'),
			telefonePrincipal: Yup.string()
				.test('telefonePrimario', 'Informe um telefone válido', val => Validators.validarTelefone(val))
				.required('Campo obrigatório'),
			telefoneSecundario: Yup.string().test(
				'telefoneSecundario',
				'Informe um telefone válido',
				val => Validators.validarTelefone(val),
			),
			endereco: Yup.object().shape({
				municipio: Yup.object().nullable().required('Campo obrigatório'),
				cep: Yup.string().required('Campo obrigatório'),
				bairro: Yup.string().trim().required('Campo obrigatório'),
				logradouro: Yup.string().trim().required('Campo obrigatório'),
				numero: Yup.string().trim().required('Campo obrigatório'),
			}),
		}),
	}),
});

export const EntradaCompraEmergencialValidationSchema = Yup.object().shape({
	id: Yup.string().required('Campo obrigatório'),
	tipoTransacao: Yup.string().required('Campo obrigatório'),
	quantidadeEntradaSaida: Yup.string().test('quantidadeEntradaSaida', 'Quantidade não deve ser inferior a 1', (value) => {
		if (value) {
			return Number(value) > 0;
		}
		return false;
	}).required('Campo obrigatório'),
	destinoEstoque: Yup.object().shape({
		tipoEstoque: Yup.string().required('Campo obrigatório'),
		numero: Yup.string().nullable().required('Campo obrigatório'),
		valorUnitario: Yup.string().required('Campo obrigatório').test('valorUnitario', 'Valor deve ser maior que R$0,00', (value) => {
			const double = value ? value.replace(/[^\d]/g, '') : null;
			if (double) {
				return Number(double) > 0;
			}
			return false;
		}),
		empresa: Yup.object().shape({
			nome: Yup.string().trim().required('Campo obrigatório'),
			cnpj: Yup.string()
				.test('cnpj', 'CNPJ inválido', (val) => {
					if (val === undefined) {
						return false;
					}
					return Validators.validarCNPJ(val);
				})
				.required('Campo obrigatório'),
			email: Yup.string()
				.test('email', 'Informe um e-mail válido', val => Validators.validarEmail(val))
				.required('Campo obrigatório'),
			telefonePrincipal: Yup.string()
				.test('telefonePrimario', 'Informe um telefone válido', val => Validators.validarTelefone(val))
				.required('Campo obrigatório'),
			telefoneSecundario: Yup.string().test(
				'telefoneSecundario',
				'Informe um telefone válido',
				val => Validators.validarTelefone(val),
			),
			endereco: Yup.object().shape({
				municipio: Yup.object().nullable().required('Campo obrigatório'),
				cep: Yup.string().required('Campo obrigatório'),
				bairro: Yup.string().trim().required('Campo obrigatório'),
				logradouro: Yup.string().trim().required('Campo obrigatório'),
				numero: Yup.string().trim().required('Campo obrigatório'),
			}),
		}),
	}),
});

export const EntradaDefesaCivilValidationSchema = Yup.object().shape({
	id: Yup.string().required('Campo obrigatório'),
	tipoTransacao: Yup.string().required('Campo obrigatório'),
	quantidadeEntradaSaida: Yup.string().test('quantidadeEntradaSaida', 'Quantidade não deve ser inferior a 1', (value) => {
		if (value) {
			return Number(value) > 0;
		}
		return false;
	}).required('Campo obrigatório'),
});


/* VALIDAÇÃO PARA MATERIAL PERMANENTE - EMPRESTIMO e ISEVENTO TRUE */
export const SaidaPermanenteComEventoValidationSchema = Yup.object().shape({
	emprestimo: Yup.string().required('Campo obrigatório'),
	isEvento: Yup.bool().required('Campo obrigatório'),
	origemEstoque: Yup.object().shape({
		id: Yup.string().required('Campo obrigatório'),
	}),
	ocorrencia: Yup.object().shape({
		id: Yup.string().required('Campo obrigatório'),
	}),
	quantidadeEntradaSaida: Yup.string().test('quantidadeEntradaSaida', 'Quantidade não deve ser inferior a 1', (value) => {
		if (value) {
			return Number(value) > 0;
		}
		return false;
	}).required('Campo obrigatório'),

});

/* VALIDAÇÃO PARA MATERIAL PERMANENTE - EMPRESTIMO e ISEVENTO FALSE */
export const SaidaPermanenteSemEventoValidationSchema = Yup.object().shape({

	emprestimo: Yup.bool().required('Campo obrigatório'),
	isEvento: Yup.bool().required('Campo obrigatório'),
	origemEstoque: Yup.object().shape({
		id: Yup.string().required('Campo obrigatório'),
	}),
	motivo: Yup.string().trim().nullable().required('Campo obrigatório'),
	destinoEmprestimo: Yup.string().trim().nullable().required('Campo obrigatório'),
	documento: Yup.string().nullable().required('Campo obrigatório'),
	quantidadeEntradaSaida: Yup.string().test('quantidadeEntradaSaida', 'Quantidade não deve ser inferior a 1', (value) => {
		if (value) {
			return Number(value) > 0;
		}
		return false;
	}).required('Campo obrigatório'),


});

/* VALIDAÇÃO PARA MATERIAL PERMANENTE - DESCARTE */
export const SaidaPermanenteDescarteValidationSchema = Yup.object().shape({

	emprestimo: Yup.string().required('Campo obrigatório'),
	motivo: Yup.string().trim().nullable().required('Campo obrigatório'),
	quantidadeEntradaSaida: Yup.string().test('quantidadeEntradaSaida', 'Quantidade não deve ser inferior a 1', (value) => {
		if (value) {
			return Number(value) > 0;
		}
		return false;
	}).required('Campo obrigatório'),
	origemEstoque: Yup.object().shape({
		id: Yup.string().required('Campo obrigatório'),
	}),

});

/* VALIDAÇÃO PARA DEVOLUÇÃO */
export const DevolucaoValidationSchema = Yup.object().shape({
	idHistoricoEmprestimoDevolucao: Yup.number().nullable().min(1, 'Campo obrigatório').required('Campo obrigatório'),
	quantidadeEntradaSaida: Yup.string().test('quantidadeDevolucao', 'Quantidade não deve ser inferior a 1', (value) => {
		if (value) {
			return Number(value) > 0;
		}
		return false;
	}).required('Campo obrigatório'),

});
